// extracted by mini-css-extract-plugin
export default {"wrapper":"Recommendation_wrapper__XwPrv","low":"Recommendation_low__cgd5s","high":"Recommendation_high__YgRcj","content":"Recommendation_content__U25EM"};